@if(objectFields) {
  <div class="list__container resizable-table">
    <table
      mat-table
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="{{artifactNameField.field_name}}" sticky>
        <th
          mat-header-cell
          *matHeaderCellDef
          (keyDown)="null"
        >
          <div
            class="list__header"
            (click)="sort(artifactNameField)"
            (keydown)="null"
          >
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (keydown)="null"
              (ngModelChange)="selectAll()"
              [(ngModel)]="searchContainer.selections.allSelected"
              [indeterminate]="checkedStatus() === 'some'"
            />

            @if(!hideNameColumn()) {
              <span>
                {{'TRANS__FIELD__NAME' | translate}}
              </span>

              @if (searchContainer.getOrder() === artifactNameField.field_name || searchContainer.getOrder() === (artifactNameField.field_name + ' desc')) {
                <mat-icon
                  class="list__sort-icon"
                  [ngClass]="{'list__sort-icon--flipped': searchContainer.getOrder() === (artifactNameField.field_name + ' desc')}"
                >
                  arrow_downward
                </mat-icon>
              }
            }
          </div>
        </th>

        <td
          id="{{row.item.artifact_id}}"
          mat-cell
          *matCellDef="let row"
        >
          <div class="list__name-column">
            <span
              class="checkbox-tooltip-wrapper"
              [class.cursor-not-allowed]="isCheckboxDisabled(row) && !row.$$used"
              [matTooltip]="isCheckboxDisabled(row) && !row.$$used ? ('TRANS__SEARCH_SELECTIONS__TOO_MANY_SELECTED' | translate) : ''"
              (click)="$event.stopPropagation()"
              (keydown)="null"
            >
              <mat-checkbox
                (click)="select(row, $event)"
                (keydown)="null"
                [checked]="isCheckboxSelected(row)"
                [disabled]="isCheckboxDisabled(row)"
              />
            </span>

            @if (!hideNameColumn()) {

              <button
                mat-icon-button
                (click)="treeControl.toggle(row)"
                [style.visibility]="!isExpandable(row) ? 'hidden' : ''"
              >
                @if(!row['isLoading']) {
                  <mat-icon>
                    {{treeControl.isExpanded(row) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                }
                @else {
                  <mat-spinner
                    diameter="16"
                  />
                }
              </button>


              <div>
                <a
                  queryParamsHandling="merge"
                  [queryParams]="row['refData']['queryParams']"
                  [routerLink]="getRouterLink(row)"
                  [style.padding-left]="row.level > 1 ? (row.level - 1) * 16 + 'px' : 0"
                  class="name-column__link"
                >
                  <mat-icon>
                    {{ iconToMaterialSymbol(row.icon) }}
                  </mat-icon>

                  @if (row.item?.is_restricted) {
                    <app-restricted-indicator/>
                  }

                  <span
                    [innerHTML]="row.name"
                  ></span>
                </a>
              </div>
            }
          </div>
        </td>
      </ng-container>

      @for (column of searchContainer.currentPathView.search_view.overview_fields; track $index) {
        <ng-container [matColumnDef]="column.$$fieldColumnName">
          <th
            mat-header-cell
            *matHeaderCellDef
            (keyDown)="null"
          >
            <div
              class="list__header"
              (click)="sort(column)"
              (keydown)="null"
            >
              <span>
                {{ column.$$fieldTitle }}
              </span>

              @if (searchContainer.getOrder() === column.field_name + "_value" ||
                  searchContainer.getOrder() === (column.field_name + '_value desc') ||
                  searchContainer.getOrder() === (column.field_name) ||
                  searchContainer.getOrder() === (column.field_name + ' desc')) {
                <mat-icon
                  class="list__sort-icon"
                  [ngClass]="{'list__sort-icon--flipped': searchContainer.getOrder() === (column.field_name + '_value desc') || searchContainer.getOrder() === (column.field_name + ' desc')}"
                >
                  arrow_downward
                </mat-icon>
              }
            </div>
          </th>

          <td
            mat-cell
            *matCellDef="let row"
          >
            @for (field of getObjectFields(row); track $index) {
              <div [title]="field.title">
                @if (column.$$fieldColumnName === field.$$fieldColumnName) {
                  <app-overview-field-value
                    [object]="row.item"
                    [viewName]="searchContainer.searchResultViewName"
                    [overviewField]="field"
                    [metaField]="column"
                    [showAllLinkItems]="false"
                    [linkVisibleItemsCount]="10"
                  />
                }
              </div>
            }
          </td>
        </ng-container>
      }

      <ng-container
        matColumnDef="setting"
        [stickyEnd]="true"
      >
        <th
          mat-header-cell
          *matHeaderCellDef
        >
          <app-operation-dropdown-menu-for-search-container
            [searchContainer]="searchContainer"
            [operationGroupId]="'list_search_view_dropdown'"
          />
        </th>

        <td
          mat-cell
          *matCellDef="let element"
        >
          <div class="list__navigation-container">
            @if (element.item.package_placement && objectPageV2) {
              <app-search-result-package-indicator
                class="list__package-navigation"
                [buttonInTable]="true"
                [item]="element.item"
                [packageDataIsObject]="true"
              />
            }

            @if (hideNameColumn()) {
              @if (!element.item.package_placement && objectPageV2) {
                <div class="list__object-navigation">
                  <button
                    mat-icon-button
                    class="list__go-to-button list__go-to-button--hidden"
                    [disabled]="true"
                  >
                    <mat-icon>
                      chevron_right
                    </mat-icon>
                  </button>
                </div>
              }
              <div class="list__object-navigation">
                <button
                  mat-icon-button
                  class="list__go-to-button"
                  [routerLink]="getRouterLink(element)"
                  [queryParams]="element['refData']['queryParams']"
                  queryParamsHandling="merge"
                >
                  <mat-icon>
                    chevron_right
                  </mat-icon>
                </button>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
  </div>
}
